import React from 'react';
import { TextField as MuiTextField } from '@material-ui/core';
import { fieldToTextField } from 'formik-material-ui';
import { DatePicker, DateTimePicker } from '@material-ui/pickers';
import { getIn } from 'formik';


/**
 * Yup and formik don't have decimal percision validations built in. These components reformat decimals to their respective percision before the form can submit.
 * @param {*} props 
 */
const DecimalControlledField = (props) => {
  const { form: { setFieldValue }, field: { name }, percision } = props;

  const onChange = React.useCallback(
    event => {
      const { value } = event.target;
      const num = parseFloat(value);
      const cleanNum = num.toFixed(percision);
      setFieldValue(name, value ? cleanNum * 1 : '');
    },
    [setFieldValue, name, percision]
  );
  return <MuiTextField {...fieldToTextField(props)} onChange={onChange} type="number" />;
};


function fieldToDatePicker({ field, form: { isSubmitting, touched, errors, setFieldValue, setFieldError }, disabled, ...props }) {
  const fieldError = getIn(errors, field.name);
  const showError = getIn(touched, field.name) && !!fieldError;
  return {
    ...props,
    ...field,
    error: showError,
    helperText: showError ? fieldError : props.helperText,
    disabled: disabled !== undefined ? disabled : isSubmitting,
    onChange(date) {
      if(date) {
        setFieldValue(field.name, date.toISOString());
      } else {
        setFieldValue(field.name, null);
      };
    }
  };
}

const DateFormik = (props) => {
  return <DatePicker {...fieldToDatePicker(props)} disabled={props.InputProps && props.InputProps.disabled}></DatePicker>
}

const DateTimeFormik = (props) => {
  return <DateTimePicker {...fieldToDatePicker(props)} disabled={props.InputProps && props.InputProps.disabled}></DateTimePicker>
}


const withDependencies = (ChildComponent, { childProps, formikProps, jsonSchema, key, children }) => {
  const { form: { values } } = formikProps;

  let depedencyCheck = null;

  if (jsonSchema.dependencies) {
    const deps = jsonSchema.dependencies;
    const check_dep = Object.keys(deps).filter(r => key in deps[r].properties);
    if (check_dep.length === 1) {
      const parent = check_dep[0];
      // const child = key;
      if (jsonSchema.properties[parent].type === "boolean") {
        depedencyCheck = values[parent];
      }
    }
  };
  return (depedencyCheck === null || depedencyCheck) &&
    <ChildComponent {...formikProps} {...childProps} required={(depedencyCheck !== null && depedencyCheck)}>{children}</ChildComponent>
}

export { DecimalControlledField, DateFormik, DateTimeFormik, withDependencies };